/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      const mm = gsap.matchMedia();

      mm.add( '(max-width: 1023px)', () => {
        $( '.project-single' ).each( function( key, val ) {
          const height = $( val ).height();

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              pin: '.project-single__link-bar-wrapper',
              start: 'top top',
              end: '+=' + ( height - window.innerHeight ),
              scrub: 0,
              // markers: true,
              onRefresh: ( self ) => {
                self.spacer.classList.add( 'pointer-events-none' );
              },
            },
          } );
        } );
      } );

      mm.add( '(min-width: 1024px)', () => {
        const images = $( '.project-single__gallery-image-wrapper' ).find( 'img' );
        const imagesLoaded = [];
        images.each( function() {
          const image = $( this );
          const imageSrc = image.attr( 'src' );
          const imageLoad = new Promise( ( resolve, reject ) => {
            const imageLoader = new Image();
            imageLoader.onload = () => resolve();
            imageLoader.onerror = ( error ) => reject( new Error( `Failed to load image: ${imageSrc}` ) );
            imageLoader.src = imageSrc;
          } );
          imagesLoaded.push( imageLoad );
        } );
        Promise.all( imagesLoaded ).then( () => {
          const xPx = $( '.project-single__inner' )[0].scrollWidth;
          const speed = 6000;

          const horizontalScroll = gsap.to( '.project-single__inner', {
            x: ( ( xPx - window.innerWidth ) * -1 ),
            ease: 'none',
            scrollTrigger: {
              trigger: '.project-single',
              scrub: 1,
              start: 'top top',
              end: '+=' + speed,
            },
          } );

          gsap.to( '.project-single__inner', {
            scrollTrigger: {
              trigger: '.project-single',
              start: 'top top',
              pin: true,
              pinSpacing: true,
              scrub: 1,
              end: '+=' + ( speed + 500 ),
            // markers: true,
            },
          } );

          gsap.to( '.project-single__link-bar-wrapper', {
            x: ( ( xPx - window.innerWidth ) ),
            ease: 'none',
            scrollTrigger: {
              trigger: '.project-single__inner',
              scrub: 1,
              start: 'top top',
              end: '+=' + speed,
            // markers: true,
            },
          } );

          if ( $( '.project-single__gallery-image-wrapper' ).length ) {
            $( '.project-single__gallery-image-wrapper' ).each( function( index ) {
              const image = $( this ).find( 'img' );
              const imageWidth = image.width();
              gsap.set( $( this ), {width: imageWidth} );
              gsap.set( image, {height: '75%'} );
              if ( index === 0 ) {
                gsap.to(
                    image,
                    {
                      height: '100%',
                      ease: 'none',
                      scrollTrigger: {
                        trigger: image,
                        containerAnimation: horizontalScroll,
                        start: 'left 660px',
                        end: 'left 120px',
                        scrub: true,
                        // markers: true,
                        invalidateOnRefresh: true,
                      },
                    },
                );
              } else {
                gsap.to(
                    image,
                    {
                      height: '100%',
                      ease: 'none',
                      scrollTrigger: {
                        trigger: image,
                        containerAnimation: horizontalScroll,
                        start: 'left 70%',
                        end: 'left 220px',
                        scrub: true,
                        // markers: true,
                        invalidateOnRefresh: true,
                      },
                    },
                );
              }
            } );
          }
        } );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'project-single', COMPONENT );
} )( app );
